// A dataset reset can replace the receipts slice with its initial state while old requests are
// pending. Keep this marker by store dispatch so it survives that reset without crossing stores.
const epochByDispatch = new WeakMap<object, number>();

export const getReceiptSessionEpoch = (dispatch: object): number => epochByDispatch.get(dispatch) ?? 0;

export const invalidateReceiptSession = (dispatch: object): void => {
  epochByDispatch.set(dispatch, getReceiptSessionEpoch(dispatch) + 1);
};
